import { ServiceFamiliesResponseDTO } from "@requests"
import {ref, Ref} from "vue"

const serviceFamiliesContentResponse: Ref<ServiceFamiliesResponseDTO | null> = ref(null)

export default serviceFamiliesContentResponse